import { getAdExamplesSSR } from "@/ssr/ad-examples"
import {
  getCategoriesForFilter,
  getInitialFilters,
} from "@/ssr/gallery"
import {
  SSRNotFound,
  SSRTemporaryRedirect,
  wrapSSRAuth,
} from "@/utils/ssr-auth"
import axios from "axios"
import axiosRetry from "axios-retry"
import {
  FilterStateAdExamples,
  MetaLinks,
} from "pages/ai-gallery"
import GalleryAll from "sections/gallery/all-gallery"
import { AdExamplesPageProps } from "."

export default function AdExamplesPage(
  props: AdExamplesPageProps,
) {
  return (
    <GalleryAll
      galleryJobs={null}
      initialFiltersGallery={null}
      availableFiltersGallery={
        props.availableFiltersGallery
      }
      templatesJobs={null}
      initialFiltersTemplates={null}
      availableFiltersTemplates={
        props.availableFiltersTemplates
      }
      adExamplesJobs={props.jobs}
      initialFiltersAdExamples={props.initial}
      pageTitle={props.pageTitle}
      metaLinks={props.metaLinks}
      pageNumber={props.pageNumber}
      initialPage="ad-examples"
    />
  )
}

export const getServerSideProps = wrapSSRAuth(
  async (context, userInfo) => {
    const id = context.params?.slug
    let page = Number(context.query.page)

    if (typeof id !== "string") {
      throw new SSRNotFound()
    }

    if (!userInfo.isAnonymous) {
      throw new SSRTemporaryRedirect(
        "/discover?filter=ad-examples&q=" +
          encodeURIComponent(id),
      )
    }

    if (isNaN(page) || page < 1) {
      page = 1
    }

    const prevNumber = page > 1 ? page - 1 : null

    const metaLinks: MetaLinks = {
      current: `/ad-examples/${id}?page=` + page,
      next: `/ad-examples/${id}?page=` + (page + 1),
      prev: prevNumber
        ? `/ad-examples/${id}?page=` + prevNumber
        : null,
    }

    const applyFilters = {
      searchQuery: id.replaceAll("-", " "),
      aspect: null,
    } as const

    const payload: FilterStateAdExamples = {
      ...applyFilters,
      applyFilters,
    }

    const token = userInfo.accessToken

    axiosRetry(axios, { retries: 3 })

    const [
      jobs,
      availableFiltersTemplates,
      availableFiltersGallery,
    ] = await Promise.all([
      getAdExamplesSSR(token, payload, page),
      getCategoriesForFilter(token),
      getInitialFilters(),
    ])

    const number =
      jobs.type === "searched" ? jobs.total : null
    const text = id
      .replaceAll("-", " ")
      .replace(/\b\w/g, (match) => match.toUpperCase())
    const title = number ? number + " " + text : text

    const props: AdExamplesPageProps = {
      jobs,
      initial: payload,
      availableFiltersTemplates,
      availableFiltersGallery,
      pageTitle: title,
      metaLinks,
      pageNumber: page,
    }

    return props
  },
  [],
)
